import ReactHtmlParser from 'react-html-parser'

export function getIFrameSource(html: string): string {
  const parsedIframe = ReactHtmlParser(html)

  if (parsedIframe.length >= 0) {
    return parsedIframe[0]?.props.src
  } else return ''
}
